import {
  Box,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Toolbar,
} from '@mui/material';
import { adminSideBarValues } from '../../data/nav/mainNav';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { changeOption } from '../../store/slices/function/sideBar-filterTabSlice';
import React, { useEffect } from 'react';

function SideBar(): React.JSX.Element {
  const dispatch = useDispatch();
  const sideBarIndex = useSelector((state: RootState) => state.sideBar);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
    name: string,
  ) => {
    dispatch(changeOption({ option: index, name: name, drawerOpen: false }));
  };

  const handleUrlPick = () => {
    let initialOption: number = 0;
    for (const item of adminSideBarValues) {
      if (item.link === window.location.pathname) initialOption = item.option;
    }
    dispatch(
      changeOption({
        option: initialOption,
        name: window.location.pathname,
        drawerOpen: false,
      }),
    );
  };

  useEffect(() => {
    handleUrlPick();
  }, []);

  return (
    <Grid container>
      <Grid
        xs={1}
        sm={1}
        md={1}
      >
        <Drawer
          variant='permanent'
          anchor='left'
          hideBackdrop={true}
          sx={{
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { boxSizing: 'border-box' },
          }}
        >
          <Toolbar />
          <Grid container>
            <Grid xs={12}>
              <Box>
                <List sx={{ overflow: 'hidden' }}>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    {adminSideBarValues.map((item) => {
                      return (
                        <Grid
                          xs={12}
                          key={item.title}
                        >
                          <ListItem disablePadding>
                            <Link to={item.link}>
                              <ListItemButton
                                tabIndex={-1}
                                onClick={(event) =>
                                  handleListItemClick(
                                    event,
                                    item.option,
                                    item.link,
                                  )
                                }
                                selected={
                                  sideBarIndex?.option === item.option &&
                                  sideBarIndex.name === item.link
                                }
                              >
                                <ListItemIcon sx={{ minWidth: '0' }}>
                                  {item.icon}
                                </ListItemIcon>
                              </ListItemButton>
                            </Link>
                          </ListItem>
                        </Grid>
                      );
                    })}
                  </Grid>
                </List>
              </Box>
            </Grid>
          </Grid>
        </Drawer>
      </Grid>
    </Grid>
  );
}

export default SideBar;
